class FeaturedVideoA {
    constructor() {
        this.videoPlay();
        this.videoModulePlay();
        this.removeAutoPlayIframe();
        this.clickvdo();
    }

 
    videoPlay() {
        const el = document.querySelectorAll('.card-video__video-play');
        if (el) {
            for (var i = 0; i < el.length; i++) {
                el[i].addEventListener('click', this.hideContent);
                if(el[i].previousElementSibling.classList.contains('card-video__video-thumbnail') && el[i].parentElement.nextSibling.classList.contains('card-video__video-iframe')){
                    el[i].parentElement.nextSibling.style.opacity = "0";
               }
            }
        }
        const el2 = document.querySelectorAll('.card-video-btn');
        if (el2) {
            for (var i = 0; i < el2.length; i++) {
                el2[i].addEventListener('click', this.playModalVideo);
            }
        }
    }

    videoModulePlay() {
        const el1 = document.querySelectorAll('.video-module__video-poster-play');
        if (el1) {
            for (var i = 0; i < el1.length; i++) {
                el1[i].addEventListener('click', this.hideContent);
                if(el1[i].previousElementSibling.classList.contains('video-module__video-poster-thumbnail') && el1[i].parentElement.nextSibling.classList.contains('iframe')){
                    el1[i].parentElement.nextSibling.style.opacity = "0";
                }
            }
        }
    }

    hideContent() {
        this.parentElement.style.display = 'none';
        this.parentElement.nextElementSibling.src += "?autoplay=1";
        this.parentElement.nextElementSibling.setAttribute('allow', 'autoplay');
        this.parentElement.nextSibling.style.opacity = "1";
    }

    removeAutoPlayIframe()
    {
        const iframeElm = document.querySelectorAll('iframe');
        if (iframeElm) {
            for (var i = 0; i < iframeElm.length; i++) {
                let url    = new URL( iframeElm[i].src );
                let params = new URLSearchParams(url.search);
                // Delete the foo parameter.
                params.delete('autoplay');
                url.search = params.toString();
                var new_url = url.toString();
                iframeElm[i].setAttribute('src', new_url );
            }
        }
    }

    clickvdo(){
        const el = document.querySelectorAll('.card-video');
        if (el) {
            for (var i = 0; i < el.length; i++) {
                el[i].addEventListener('click', this.playvdo);
                if(el[i].querySelector(':scope > .card-figure') && el[i].querySelector(':scope > .iframe-video')){
                    el[i].querySelector(':scope > .iframe-video').style.opacity = "0";
                }
            }
        }
    }
    
    playvdo(){
        if(this.querySelector(':scope > .btn-control')){
            this.querySelector(':scope > .btn-control').style.display = "none";
        }
        if( this.querySelector(':scope > .card-figure') ){
            this.querySelector(':scope > .card-figure').style.display = "none";
        }
        if(this.querySelector(':scope > .iframe-video') ){
            this.querySelector(':scope > .iframe-video').src += "?autoplay=1";
            this.querySelector(':scope > .iframe-video').style.opacity = "1";
        }
    }

}

export default FeaturedVideoA;
new FeaturedVideoA();
